import { RootState } from 'handlers';

export const getReportsState = (state: RootState) => state.reports;
export const getOffersData = (state: RootState) => state.reports.offers;
